import { useEffect, useReducer } from 'react';
import { hysteriFetch } from 'hysterics';

const fetchVehicleViews = hysteriFetch('ws-vehicle-title-views');
const newrelicAction = (action, facets) => {
	if (window && window.newrelic && typeof window.newrelic === 'object') {
		window.newrelic.addPageAction(action, facets);
	}
};
const vehicleViewsRequestReducer = (state, action) => {
	switch (action.type) {
		case 'VIEWS_REQUEST_SUCCESS':
			return {
				...state,
				isLoading: false,
				hasViewsData: true,
				numberOfViews: action.payload
			};
		case 'VIEWS_REQUEST_FAILURE':
			return {
				...state,
				isLoading: false,
				hasError: true
			};
		case 'VIEWS_REQUEST_SKIPPED':
		default:
			return {
				...state,
				isLoading: false
			};
	}
};

const useVehicleViews = (vin, timeFrame, shouldRequest) => {
	const initialState = {
		isLoading: true,
		hasError: false,
		hasViewsData: false,
		numberOfViews: 0
	};

	const [state, dispatch] = useReducer(
		vehicleViewsRequestReducer,
		initialState
	);

	useEffect(() => {
		let shouldDispatch = true;

		(async () => {
			if (shouldRequest && vin && timeFrame) {
				const ENDPOINT_FETCH =
					'/api/widget/ws-vehicle-title/getVehicleViews';
				try {
					const response = await fetchVehicleViews(ENDPOINT_FETCH, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							parameters: { vin, timeframe: timeFrame }
						})
					});

					if (shouldDispatch) {
						const hasValidViewCount =
							response?.DDC || response?.DDC === 0;
						if (hasValidViewCount) {
							dispatch({
								type: 'VIEWS_REQUEST_SUCCESS',
								payload: response.DDC
							});
						} else {
							newrelicAction(
								'VEHICLES_TITLE_INVALID_VIEW_COUNT',
								{
									requestUrl: ENDPOINT_FETCH,
									vin,
									timeFrame,
									errorMessage:
										'Invalid view count received from endpoint'
								}
							);
							dispatch({
								type: 'VIEWS_REQUEST_FAILURE'
							});
						}
					}
				} catch (err) {
					if (shouldDispatch) {
						newrelicAction('VEHICLES_TITLE_ENDPOINT_FETCH_ERROR', {
							requestUrl: ENDPOINT_FETCH,
							errorMessage: err.message,
							errorStack: err.stack,
							vin,
							timeFrame
						});
						dispatch({
							type: 'VIEWS_REQUEST_FAILURE'
						});
					}
				}
			} else if (shouldDispatch) {
				dispatch({
					type: 'VIEWS_REQUEST_SKIPPED'
				});
			}
		})();

		// Prevent dispatch after component unmounts
		return () => {
			shouldDispatch = false;
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return state;
};

export default useVehicleViews;
